<template>
  <div
    :style="{ 'border-color': isActive ? '#1a93ca' : '#ebebeb' }"
    class="cover"
    @click="setActive"
  >
    <div class="product-tile">
      <div
        v-if="title === 'Lease to Own (LO)' || title === 'Outright Sale (OS)'"
      >
        <img
          v-if="!isActive"
          :src="require('../../../assets/img/lo-close-door.svg')"
          alt="x"
        />
        <img
          v-if="isActive"
          :src="require('../../../assets/img/lo-door.svg')"
          alt="x"
        />
      </div>

      <div
        v-if="
          title === 'Arnergy 10000' ||
            title === 'Arnergy IPP' ||
            title === 'Arnergy 5000' ||
            title === 'Arnergy 5000X'
        "
      >
        <img
          v-if="title === 'Arnergy 10000'"
          :src="require('../../../assets/img/arnergy-10000x.png')"
          :style="{ filter: isActive ? 'none' : 'grayscale(100%)' }"
          alt="x"
          class="prod-img-x"
        />
        <img
          v-if="title === 'Arnergy 5000'"
          :src="require('../../../assets/img/arnergy-5000.png')"
          :style="{ filter: isActive ? 'none' : 'grayscale(100%)' }"
          alt="x"
          class="prod-img-x"
        />
        <img
          v-if="title === 'Arnergy IPP'"
          :src="require('../../../assets/img/arnergy-5000.png')"
          :style="{ filter: isActive ? 'none' : 'grayscale(100%)' }"
          alt="x"
          class="prod-img-x"
        />
        <img
          v-if="title === 'Arnergy 5000X'"
          :src="require('../../../assets/img/arnergy-5000.png')"
          :style="{ filter: isActive ? 'none' : 'grayscale(100%)' }"
          alt="x"
          class="prod-img-x"
        />
      </div>

      <h3 class="title" :style="{ color: isActive ? '#0892D0' : '#C4C4C4' }">
        {{ title ? title : "no_title" }}
      </h3>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "OnboardingSelectButton",
  components: {},
  props: ["title", "ID", "description", "isActive"],

  computed: {},
  data() {
    return {};
  },
  methods: {
    setActive() {
      this.$emit("setActive");
    },
    url() {}
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/_reduced_variables.scss";

.cover {
  border: 3px solid;
  border-radius: 20px;
  max-width: 300px;
  overflow: hidden;
  cursor: pointer;
  text-align: center;
  color: #999999;
  margin-right: 2.6rem;
}

.title {
  margin-top: 1.6rem;
  font-weight: normal;
  font-size: 16px;
}

.product-tile {
  padding: 2.6rem;
}

.prod-img {
  width: 10rem;
  height: 20rem;
}

.prod-img-x {
  height: 15rem;
}

.grey-image {
  filter: grayscale(100%);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/OnboardingSelectButton.vue